import { Trans, t } from "@lingui/macro";
import image from "./img/finish-success.svg";

const FinishSuccess = () => (
  <div className="flex flex-col items-center py-12 px-6">
    <h1 className="font-bold text-4xl text-center mb-12 w-1/2 leading-normal">
      <Trans>Done! The project has been successfully closed.</Trans>
    </h1>
    <img width="300" src={image} alt={t`finish success illustration`} />
  </div>
);

export default FinishSuccess;
